'use client';

import React, { useEffect, useRef, useState } from 'react';
import { useMotionValueEvent, useScroll } from 'framer-motion';

import FeatureWorkScrollItem from '@/components/features/FeatureWorkScrollItem';
import FeatureWorkScrollSub from './FeatureWorkScrollSub';

function FeatureWorkScroll({ workData, t, lang }) {
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const itemsRef = useRef<HTMLDivElement | null>(null);
  const [isVisibleSticky, setIsVisibleSticky] = useState(false);
  const [itemStyle, setItemStyle] = useState(0);

  const { scrollY } = useScroll();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 找到當前可見的 section 對應的 index
            const sectionId = entry.target.id;
            const index = workData.findIndex(
              (item) => item.query === sectionId,
            );
            if (index !== -1) {
              setItemStyle(index);
            }
          }
        });
      },
      {
        threshold: 0.5, // 當 section 有 50% 進入視窗時觸發
        rootMargin: '-100px 0px -100px 0px', // 調整觀察範圍
      },
    );

    // 觀察所有 section
    workData.forEach((item) => {
      const section = document.getElementById(item.query);
      if (section) {
        observer.observe(section);
      }
    });

    return () => {
      observer.disconnect();
    };
  }, [workData]);

  useMotionValueEvent(scrollY, 'change', () => {
    if (scrollRef.current && itemsRef.current) {
      const elementTop = scrollRef.current.getBoundingClientRect().top;
      const itemsHeight = itemsRef.current.offsetHeight; // 獲取項目區塊的高度

      setIsVisibleSticky(elementTop < -itemsHeight); // 當元素頂部超過項目區塊高度時顯示
    }
  });

  return (
    <>
      <section className="relative" ref={scrollRef}>
        <div className="grid px-5 py-6">
          <p className="text-center text-lg md:text-4xl md:font-600">
            {t.featureScrollTitle}?
          </p>
          <div
            ref={itemsRef}
            className="grid w-full grid-cols-2 gap-4 pt-4 transition-all duration-700 md:flex md:gap-6 md:px-20"
          >
            {workData.map((data, index) => (
              <div
                key={data.id}
                className={`${
                  workData.length % 2 === 0
                    ? 'col-span-1'
                    : 'last:col-span-full'
                } w-full`}
              >
                <FeatureWorkScrollItem
                  title={data.title}
                  icon={data.icon}
                  query={data.query}
                  itemStyle={itemStyle}
                  index={index}
                  href={data.href}
                  lang={lang}
                  t={t}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      <FeatureWorkScrollSub
        workData={workData}
        itemStyle={itemStyle}
        isVisibleSticky={isVisibleSticky}
        t={t}
        lang={lang}
      />
    </>
  );
}

export default FeatureWorkScroll;
